var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M19.68 1.92H4.32a2.4 2.4 0 0 0-2.4 2.4v15.36a2.4 2.4 0 0 0 2.4 2.4h15.36a2.4 2.4 0 0 0 2.4-2.4V4.32a2.4 2.4 0 0 0-2.4-2.4ZM8.16 9.6v9.12H5.28V9.6h2.88ZM5.28 6.946c0-.672.576-1.186 1.44-1.186s1.406.514 1.44 1.186c0 .672-.538 1.214-1.44 1.214-.864 0-1.44-.542-1.44-1.214ZM18.72 18.72h-2.88v-4.8c0-.96-.48-1.92-1.68-1.94h-.038c-1.162 0-1.642.99-1.642 1.94v4.8H9.6V9.6h2.88v1.229S13.406 9.6 15.269 9.6c1.905 0 3.451 1.31 3.451 3.965v5.155Z",
    opacity: 0.4
  })));
};
export default SvgLinkedin;